module.exports = __webpack_public_path__ + "assets/img/peo3.24dd3aef.png";